const Dashboard = () => {
  return (
    <section className="admin-dashboard">
      <h2>Dashboard</h2>
      <p>Bienvenido al panel administrativo. Próximamente veremos métricas aquí.</p>
    </section>
  );
};

export default Dashboard;


